import { createContext, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { isMobile } from 'react-device-detect';
import { createAnalyticsEvent } from '@/api/query/analytics';
import { ANALYTICS_DEVICE_TYPE } from '@/common/constants/analyticsEvents';
import { isAuthenticated } from '@/common/contexts/GuestAuthContext';

const AnalyticsContext = createContext(null);

export const AnalyticsProvider = ({ children }) => {
	const { mutate } = useMutation({
		mutationFn: createAnalyticsEvent,
	});

	const trackAnalytics = (name, props) => {
		if (!isAuthenticated() || !name) {
			return;
		}

		const event = {
			name,
			url_source: `${window.location.pathname}${window.location.search}`,
			device_type: isMobile
				? ANALYTICS_DEVICE_TYPE.MOBILE
				: ANALYTICS_DEVICE_TYPE.DESKTOP,
			device_description: window.navigator.userAgent,
		};

		if (props && Object.keys(props).length > 0) {
			event.props = props;
		}

		mutate(event);
	};

	return (
		<AnalyticsContext.Provider value={{ trackAnalytics }}>
			{children}
		</AnalyticsContext.Provider>
	);
};

export default AnalyticsProvider;

export const useAnalytics = () => {
	const context = useContext(AnalyticsContext);

	if (!context) {
		throw new Error('useAnalytics must be used within AnalyticsProvider');
	}

	return context;
};
